import {useTranslation} from "react-i18next";
import React from "react";
import PropTypes from "prop-types";

const formatDate = (date, language) => {
    if (!date) {
        return '-';
    }

    return new Intl.DateTimeFormat(language, {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    }).format(new Date(date));
};

const RecordViews = ({views, created, duration}) => {
    const { t, i18n } = useTranslation();
    return (
        <span>
            {t('record_views_header')}: {views} | {t('record_added_date')}: {formatDate(created, i18n.language)} | {t('record_duration')}: {duration}
        </span>
    );
};

RecordViews.propTypes = {
    views: PropTypes.string.isRequired,
    created: PropTypes.string,
    duration: PropTypes.number
}

export default RecordViews;
